import {
  CORPUS_QA,
  DATAVOYAGER,
  PAPER_FINDER,
  TABLE_ANNOTATION,
} from 'configs/NoraVariants';
import { Message } from '@/models/Message';
import { optAppConfig } from '@/utils/config';

export const getPlatformLabel = (
  noraExperienceVariant: string | null,
): string => {
  switch (noraExperienceVariant) {
    case PAPER_FINDER:
      return 'Paper Finder';
    case CORPUS_QA:
      return 'Scholar QA';
    case DATAVOYAGER:
      return 'Data Voyager';
    case TABLE_ANNOTATION:
      return 'Table Annotation';
    default:
      return 'Asta';
  }
};

// Util to get the sender name from a message
// the bot's name changes depending on the variant
export const getSenderNameFromMessage = (
  message: Message,
  isAstaOverride: boolean = false,
): string => {
  const noraExperienceVariant = optAppConfig((_) => _.experience.variant);
  const botName = getPlatformLabel(noraExperienceVariant);
  const isAsta = isAstaOverride || isMessageFromAsta(message);
  return isAsta ? botName : message.sender.displayName || 'User';
};

export const isMessageFromAsta = (message: Message): boolean => {
  return (
    message.sender.displayName === 'asta' || // HACK: Should get from context
    message.sender.displayName === 'nora'
  ); // LEGACY: for existing messages before the bot was renamed to 'asta'
};
